'use strict';

// Bootstrap file that does any initialization needed and returns the top level view component.

// GROWTH-444 need this file just loaded on the page to fix chosen plugin
require('../thirdParty/chosen/0.9.x/jquery.chosen.edited');
require('../global/modules/recentHistory/recentHistory');

const { createReducerStore } = require('fluxible-reducer-store');
const Relay = require('react-relay');

const {NAME_PINTEREST} = require('bunsen/models/identity/SocialNetwork');
const User = require('../global/models/User');

// Stores
const ContactDealerStore = createReducerStore(require('./stores/ContactDealerStore.es'));
const ContactTransactionStore = require('../contact/shared/stores/ContactTransactionStore.es');
const ItemStore = require('./stores/ItemStore.es');
const UserStore = require('../global/stores/UserStore.es');
const PdpUiStore = require('./stores/PdpUiStore.es');
const TourStore = require('../components/Tour/TourStore');
const StickyAlertTopStore = require('../components/StickyAlert/StickyAlertTop/StickyAlertTop-store');
const FavoritesStore = require('../global/stores/FavoritesStore');
const FavoritePageStore = require('../global/stores/FavoritePageStore');
const PinterestStore = require('../global/stores/PinterestStore');
const TradeMessageStore = require('../global/stores/TradeMessageStore');
const UserSocialNetworkStore = require('../user/stores/UserSocialNetworkStore');
const CalloutStore = require('../components/Callout/CalloutStore');
const {TYPE_DEALER} = require('bunsen/models/identity/Favorite');
const PriceStore = require('../global/stores/PriceStore.es');
const GalleryStore = require('../gallery/stores/GalleryStore.es');

// Components
const PdpLayout = require('./components/PdpLayout');

// Helpers
const SV = require('server-vars');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const newsy = require('newsy');

const tourTracking = require('../global/tracking/tourTracking');

const pinterestCopy = require('../global/components/Pinterest/pinterest.json');

const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');
const { MASQUERADE_BUYER } = cookieJarConstants;

const {type: {TRADE_TOUR, NET_PRICE_TOUR, REQUEST_ITEM_HOLD_TOUR}} = TourStore;

const PdpLayoutConnected = Relay.createContainer(provideContext(connectToStores(
    PdpLayout,
    [
        UserStore,
        ContactDealerStore,
        ContactTransactionStore,
        ItemStore,
        PdpUiStore,
        StickyAlertTopStore,
        FavoritesStore,
        FavoritePageStore,
        PinterestStore,
        UserSocialNetworkStore,
        CalloutStore,
        TourStore,
        TradeMessageStore,
        PriceStore,
        GalleryStore
    ],
    (context) => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const contactDealerStore = context.getStore(ContactDealerStore);
        const optimizelyVariant = contactDealerStore.getVariant();
        const isMessageSent = contactDealerStore.getMessageSent();
        const isMessageSending = contactDealerStore.getMessageSending();
        const hasTrackingFired = contactDealerStore.getTrackingFired();
        const contactDealerErrors = contactDealerStore.getErrors();
        const uiStore = context.getStore(PdpUiStore);
        const stickyAlertTopStore = context.getStore(StickyAlertTopStore);
        const pinterestStore = context.getStore(PinterestStore);
        const userSocialNetworkStore = context.getStore(UserSocialNetworkStore);
        const calloutStore = context.getStore(CalloutStore);
        const favoritePageStore = context.getStore(FavoritePageStore);
        const tourStore = context.getStore(TourStore);
        const tradeMessageStore = context.getStore(TradeMessageStore);
        const itemModel = itemStore.getItem();
        const priceStore = context.getStore(PriceStore);
        const currency = userStore.getCurrency();
        const processedPriceData = priceStore.processPrice(itemModel);

        const { salePriceData = {},
            netPriceData = {},
            retailPriceData = {},
            originalPriceData,
            canRequestNetPrice,
            ctas,
            priceDisplays } = processedPriceData;
        // Set the item ID as the PK directly
        const itemId = itemStore.getFromSV('data.pk');
        // GROWTH-1908: test for making offer in contact dealer form
        const offer = context.getStore(ContactTransactionStore).offer;
        const offerAmount = offer && offer.get('amountPerItem.amount');
        // end test

        return {
            userId: getUserId(document.cookie, MASQUERADE_BUYER),
            title: itemStore.getFromItemModel('title'),
            currency,
            currencyLoaded: userStore.isCurrencyLoaded(),
            item: itemModel,
            itemId,
            itemHidePrice: itemStore.getHidePrice(),
            itemCategories: itemStore.getItemCategoryGroup(),
            itemImages: itemStore.getFromSV('item.images'),
            itemPrice: itemStore.getPrice(),
            itemInitialPrice: itemStore.getInitialPrice(),
            itemCanMakePurchase: itemStore.getCanMakePurchase() || false,
            itemDescription: itemStore.getFromItemModel('description'),
            customizationNote: itemStore.getCustomizationNote(),
            itemCreationDate: itemStore.getFromItemModel('classification.creationDate'),
            itemIsArt: itemStore.getIsArt(),
            itemIsFurniture: itemModel.isFurniture(),
            itemTitle: itemStore.getFromItemModel('title'),
            itemVertical: itemStore.getFromItemModel('vertical'),
            itemPk: itemId,
            isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
            itemIsOnHold: itemStore.getIsOnHold(),
            itemIsSold: itemStore.getIsSold(),
            itemIsUnlisted: itemStore.getIsUnlisted(),
            shouldShowSuspended: itemStore.getShouldShowSuspended(),
            creatorData: itemStore.getCreatorData(),
            creatorContent: itemStore.getFromSV('creatorContent'),
            dealerData: itemStore.getDealerData(),
            dealerRelatedItems: itemStore.getFromSV('carousel'),
            recommendedCarousel: itemStore.getFromSV('recommendedCarousel'),
            topRecommendations: itemStore.getFromSV('topRecommendations'),
            recommendedPhotos: itemStore.getFromSV('recommendedPhotos') || [],
            dealerPk: itemStore.getFromSV('data.dealerPk'),
            canonicalUrl: itemStore.getFromSV('data.canonicalUrl'),
            url: itemStore.getUrl(),
            urlData: itemStore.getUrlData(),
            askingPrice: itemStore.getFromSV('tracking.initialDataLayerInfo.askingPrice'),
            isPreview: itemStore.getIsPreview(),
            isAsyncItemLoaded: itemStore.getIsAsyncItemLoaded(),
            heroCarouselIndex: uiStore.getHeroCarouselIndex(),
            heroExpanded: uiStore.getHeroExpanded(),
            heroChangingSize: uiStore.getHeroChangingSize(),
            detailsTitles: itemStore.getDetailsTitles(),
            details: itemStore.getDetails(),
            detailsConfig: itemStore.getDetailsConfig(),
            internalLinks: itemStore.getFromSV('internalLinks'),
            siteProtocol: itemStore.getFromSV('settings.siteProtocol'),
            socialData: itemStore.getSocialData(),
            returnPolicy: itemStore.getFromItemModel('returnPolicy'),
            customHold: itemStore.getFromItemModel('activeHold'),
            returnMessage: itemStore.getReturnMessage(),
            breadcrumbs: itemStore.getBreadcrumbs(),
            goodRelationsMeta: itemStore.getGoodRelationsMeta(),
            copy: itemStore.getCopy(),
            supportCopy: itemStore.getSupportCopy(),
            buyerAssuranceProps: uiStore.getBuyerAssuranceProps(),
            // enableRequestNetPrice is for the net price button
            enableRequestNetPrice: uiStore.getEnableNetPrice(),
            // contact dealer items
            contactDealerErrors,
            hasTrackingFired,
            isDealerMessageSending: isMessageSending,
            isDealerMessageSent: isMessageSent,
            isReturnable: itemStore.getFromItemModel('returnPolicy.accept'),
            offer,
            offerAmount, // GROWTH-1908: test
            optimizelyVariant,
            price: itemModel.getPriceIn('RETAIL', currency), // GROWTH-1908: test
            trackingVpvParams: itemStore.getVpvParams(canRequestNetPrice),
            user: User.getCurrentUser(),
            userDisplayName: contactDealerStore.getName(),
            userMessage: contactDealerStore.getMessage(),
            // end contact dealer items
            isTradeUser: canRequestNetPrice,
            originalPrice: originalPriceData.price,
            salePrice: salePriceData.price,
            netPrice: netPriceData.price,
            retailPrice: retailPriceData.price,
            ctas,
            priceDisplays,
            isNegotiablePrice: itemStore.isNegotiablePrice(),
            pageData: itemStore.getPageData(),
            stickyAlertTopHeight: stickyAlertTopStore.getHeight(),
            tradeReturnsEnabled: itemStore.isTradeReturnsEnabled(),
            tradeReturnAvailable: itemStore.isTradeReturnAvailable(),
            favoriteDealerCta: SV.get('favoriteCta.dealer'),
            favoriteDealer: {
                id: favoritePageStore.getFavoriteId(TYPE_DEALER),
                isSaved: favoritePageStore.isSaved(TYPE_DEALER),
                isFetched: favoritePageStore.isFetched(TYPE_DEALER),
                isCanceled: favoritePageStore.isCanceled()
            },
            pinterest: {
                isLoaded: userSocialNetworkStore.isLoaded(),
                connected: userSocialNetworkStore.getConnectedSocialNetwork(NAME_PINTEREST),
                connectedBoard: pinterestStore.getConnectedBoard(),
                connectAccountsModal: pinterestStore.getConnectAccountsModal(),
                connectBoardModal: pinterestStore.getConnectBoardModal(),
                boards: pinterestStore.getBoards(),
                copy: pinterestCopy
            },
            callout: calloutStore.getCalloutData(),
            netPriceTour: {
                type: NET_PRICE_TOUR,
                copy: SV.get(`tourCopy.${NET_PRICE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(NET_PRICE_TOUR),
                currentStep: tourStore.getCurrentStep(NET_PRICE_TOUR),
                totalSteps: tourStore.getTotalSteps(NET_PRICE_TOUR),
                onCtaClick: tourTracking.trackCta,
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            },
            tradeTour: {
                type: TRADE_TOUR,
                subType: priceDisplays.showNetPrice ? 'preQuotedNetPrice' : 'requestNetPrice',
                copy: SV.get(`tourCopy.${TRADE_TOUR}`),
                isTourOpen: tourStore.isTourOpen(TRADE_TOUR),
                currentStep: tourStore.getCurrentStep(TRADE_TOUR),
                totalSteps: tourStore.getTotalSteps(TRADE_TOUR),
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            },
            requestItemHoldTour: {
                type: REQUEST_ITEM_HOLD_TOUR,
                copy: SV.get(`tourCopy.${REQUEST_ITEM_HOLD_TOUR}`),
                isTourOpen: tourStore.isTourOpen(REQUEST_ITEM_HOLD_TOUR),
                currentStep: tourStore.getCurrentStep(REQUEST_ITEM_HOLD_TOUR),
                totalSteps: tourStore.getTotalSteps(REQUEST_ITEM_HOLD_TOUR),
                onCtaClick: tourTracking.trackCta,
                onOpen: tourTracking.trackOpen,
                onClose: tourTracking.trackClose
            },
            isAnyTourOpen: tourStore.isAnyTourOpen(),
            tradeMessage: {
                tradeSalesRep: userStore.getTradeSalesRep(),
                isVisible: tradeMessageStore.canShowMessage(),
                userFirstName: User.getCurrentUser().get('profile.firstName')
            },
            isPrintNP: uiStore.getIsPrintNP(),
            isPrintPage: uiStore.getIsPrintPage(),
            maytest: itemStore.getFromSV('settings.maytest'),
            sellerResponseTime: itemStore.getFromSV('data.sellerResponseTime')
        };
    }
)), {
    fragments: {
        viewer: () => Relay.QL`
            fragment on Viewer {
                ${PdpLayout.getFragment('viewer')}
            }
        `
    }
});

newsy.register([
    require('bunsen/models/usercomm/MessageRecipient'),
    require('bunsen/models/usercomm/ConversationMember')
]);

module.exports = PdpLayoutConnected;



// WEBPACK FOOTER //
// ./assets/js/newPdp/index.es.js